import * as React from 'react'
import * as classNames from 'classnames'

import { LabelSquare } from '~/atoms/label/LabelSquare'
import * as Style from './style.css'

export interface IProps {
  thumbnailUrl: string
  label: string
  labelColor?: 'highlight' | 'notice' | 'warning'
  children: React.ReactNode
}

export const ThumbnailAndLabelWrapper = (props: IProps): JSX.Element => {
  return (
    <div className={classNames(Style.wrapper, 'rsv-reserve-list-block')}>
      <div className={Style.thumbnailArea}>
        <img src={props.thumbnailUrl} className={Style.thumbnailAreaImage} />
      </div>
      <div>{props.children}</div>
      <div className={Style.labelArea}>
        <LabelSquare width={80} height={23} color={props.labelColor}>
          {props.label}
        </LabelSquare>
      </div>
    </div>
  )
}

export default ThumbnailAndLabelWrapper
